import template from './company_search_component.html';

class CompanySearchComponentViewModel
{
	constructor (params)
	{
		this.params = params;

		this.companies = ko_helper.safe_observableArray();
		this.selected_company = ko_helper.safe_observable(params.selected_company || '');
		this.search_string = ko.observable('');

		// Computed observable for dynamically updating the placeholder
		this.placeholderText = ko.pureComputed(() => {
			return this.selected_company() != null ? `Selected company: ${this.selected_company().company}` : "Search company...";
		});

		this.search_string.subscribe((newValue) => {
			this.updateData();
		});
	}

	async init()
	{
		await this.updateData();
	}

	async updateData()
	{
		let options = {
			table: 'company',
			schema: 'public',
			limit: 10000,
			filter_join: 'OR',
			filter: []
		};

		if (this.search_string() && this.search_string() != '')
		{
			options.filter.push({
				field: 'company',
				operand: 'ILIKE',
				value: `%${this.search_string()}%`,
			});

			let result = await Grape.fetches.getJSON('/api/record', options);
			if (result.status != 'ERROR')
				if (result.records != null)
					this.companies(result.records);
		}
		else
			this.companies([]);
	}

	company_click (selected)
	{
		this.selected_company(selected);
		this.search_string('');
	}

	clear_selected_option ()
	{
		this.selected_company(null);
		this.search_string('');
	}
}

export default {
	name: 'company_search_component',
	viewModel: CompanySearchComponentViewModel,
	module_type: 'ko',
	template: template,
	template_filename: 'translation/components/company_search_component'
};
